import { isSignOutApiBlocked } from "@sukha/query/signOutGate";

/**
 * Browser member API fetch — respects the client sign-out gate (no network during teardown).
 * Server code should use native `fetch` directly.
 */
export async function memberFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  if (isSignOutApiBlocked()) {
    throw new DOMException("Sign-out in progress", "AbortError");
  }
  return fetch(input, init);
}
